import { getHttpClient } from 'src/http-client';

export async function getWorkitemPriorityService(args: {
  organizationName: string;
  projectId: string;
	workItemType: string
}) {
	const api = getHttpClient();
	try {
		const response = await api.get(`https://dev.azure.com/${args.organizationName}/${args.projectId}/_apis/wit/workitemtypes/${args.workItemType}/fields/Microsoft.VSTS.Common.Priority?$expand=All&api-version=6.0`);
		if (response.status === 200) {
			return response.data;
		}

		return null;
	} catch (err) {
		throw new Error('Get work item priority error.');
	}
}